import { usePath } from '../shared/router.ts';
import { Splash } from './Splash.tsx';
import { Gallery } from './Gallery.tsx';

/**
 * The gallery owns both /g and /g/:assetId, so a client can link someone
 * straight to one photograph -- which still needs their session cookie.
 */
export function App(): React.JSX.Element {
  const path = usePath();

  return path.startsWith('/g') ? <Gallery /> : <Splash />;
}
